import {
    MgbwLineProperties,
    MgbwSelectionEntry,
    parseMgbwSelections,
} from "@tSurya/Common/MgbwConfiguratorHelpers";
import { MGBW_SELECTIONS } from "@tSurya/Common/MgbwPropertyKeys";
import { useMemo } from "react";

/**
 * Memoized parse of all MGBW configurator selections from a line's properties.
 * Recomputes only when the raw mgbw_selections JSON string changes.
 * @param properties The line properties dictionary (cart line, wish list line, etc.).
 */
export function useMgbwSelections(properties: MgbwLineProperties): MgbwSelectionEntry[] {
    const raw = properties?.[MGBW_SELECTIONS];
    return useMemo(() => parseMgbwSelections(raw), [raw]);
}

/**
 * Memoized parse of the visible MGBW configurator selections from a line's properties.
 * Recomputes only when the raw mgbw_selections JSON string changes.
 * @param properties The line properties dictionary (cart line, wish list line, etc.).
 */
export function useVisibleMgbwSelections(properties: MgbwLineProperties): MgbwSelectionEntry[] {
    const raw = properties?.[MGBW_SELECTIONS];
    return useMemo(() => parseMgbwSelections(raw).filter(entry => entry.Visible), [raw]);
}
